import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbStepClass } from '../Classes/BreadcrumbStepClass';

@Component({
	standalone: false,
	selector: 'breadcrumbs',
	template: `
		<div *ngIf="showBackButton" (click)="goBack()" class="goBack">
			<svg viewBox="0 0 256 256" class="svg_arrowLeft">
				<polygon class="fill" points="106.51 127.84 173.5 60.85 150.65 38 60.5 127.84 150.65 218 173.5 195.15 106.51 127.84"></polygon>
			</svg>
			<p class="paragraph">{{ 'Common.Button.Back' | translate }}</p>
		</div>

		<div class="content">
			<ul class="breadList">
				<ng-template ngFor let-step [ngForOf]="steps" let-i="index">
					<li
						class="breadList__item"
						[class.clickable]="enableNavigation && i < currentStep"
						[class.disabled]="i > currentStep"
						[class.selected]="i === currentStep"
						*ngIf="step.url === null && crumLimitation(i)"
						(click)="clickedBreadcrumb(step, i)"
					>
						<a class="link">{{ step.label }}</a>
					</li>
					<li
						class="breadList__item"
						[class.clickable]="enableNavigation && i < currentStep"
						[class.selected]="i > currentStep"
						*ngIf="step.url !== null && crumLimitation(i)"
					>
						<a class="link" [routerLink]="step.url">{{ step.label }}</a>
					</li>

					<li class="breadList__item" *ngIf="i === 1 && maxCrumbs !== null && steps.length > maxCrumbs">...</li>

					<li
						class="breadList__item"
						[class.disabled]="i >= currentStep"
						*ngIf="steps.length === i + 2 || (steps.length !== i + 1 && crumLimitation(i))"
					>
						<svg viewBox="0 0 256 256" class="svg_arrowRight">
							<polygon
								class="fill"
								points="138.49 128.16 71.5 195.15 94.35 218 184.5 128.16 94.35 38 71.5 60.85 138.49 128.16"
							></polygon>
						</svg>
					</li>
				</ng-template>
			</ul>
			<ng-content></ng-content>
		</div>
	`,
	styleUrls: ['../Css/Components/breadcrumbs.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent implements OnInit {
	@Input() public steps: Array<BreadcrumbStepClass> = [];
	@Input() public maxCrumbs: number = null;
	@Input() public showBackButton = true;
	@Input() public startingStep: number | null = null;
	@Input() public enableNavigation = true;
	public currentStep: number = 0;
	public overrideBackButtonUrl: string = null;

	constructor(
		private _router: Router,
		private _location: Location,
	) {}

	ngOnInit() {
		if (!this.steps.length) return;
		this.startingStep !== null ? this.setCurrentStep(this.startingStep) : this.setCurrentStep(this.steps.length - 1);
	}

	clickedBreadcrumb(step: BreadcrumbStepClass, index: number) {
		if (this.currentStep <= index || !this.enableNavigation) return;
		this.setCurrentStep(index);
		step.callback(step, index);
	}

	goBack() {
		if (this.overrideBackButtonUrl !== null) {
			this._router.navigateByUrl(this.overrideBackButtonUrl);
			return;
		}

		const step = this.steps[this.steps.length - 2];

		if (step.url !== null) {
			this._router.navigateByUrl(step.url);
		} else if (step.callback !== null) {
			step.callback(step, this.steps.length - 2);
		} else {
			this._location.back();
		}
	}

	// Show ... instead of crumb
	crumLimitation(index: number) {
		if (this.maxCrumbs === null) return true;
		if (index === 0) return true;
		if (this.steps.length <= this.maxCrumbs) return true;

		return this.steps.length - index < this.maxCrumbs - 1; // [1,2,3,4,5,6].forEach((i) => console.log(6-i < 3-1));
	}

	public setCurrentStep(step: number) {
		this.currentStep = step;
	}
}
